module.exports = __webpack_public_path__ + "img/1439336923.45c56c4a.jpg";